var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.ressource)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.ressource)}}):(!_vm.hideIfEmpty)?_c('span',[_vm._v("["+_vm._s(_vm.code)+"]")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }